import http from "@/http-common"

class AttachmentDataService {
    getAll(url) {
        return http.get(`attachments${ url }`)
    }

    get(id) {
        return http.get(`attachments/${ id }`)
    }

    post(data) {
        return http.post('attachments', data)
    }

    patch(id, data, headers) {
        return http.patch(`attachments/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`attachments/${ id }`)
    }
}

export default new AttachmentDataService()